import { SiteLayout } from '@/components/site/SiteLayout'
import { PolicyShell, PolicySection } from '@/components/site/PolicyShell'

const UPDATED = '2026-05-25'

export function AccessibilityPage() {
  return (
    <SiteLayout>
      <PolicyShell title="Accessibility" updated={UPDATED}>
        <PolicySection heading="Goals">
          <p>
            GeoBorder aims to be usable by everyone, including people who
            navigate the web with screen readers, keyboards, voice controls,
            or other assistive technology. We target conformance with the
            Web Content Accessibility Guidelines (WCAG) 2.1 at Level AA
            where reasonably achievable for a free service.
          </p>
        </PolicySection>

        <PolicySection heading="What we do">
          <ul>
            <li>
              Semantic HTML with proper headings, landmarks, and form labels.
            </li>
            <li>
              Visible keyboard focus indicators throughout the interface.
            </li>
            <li>
              Adequate color contrast in both light and dark modes for body
              text and interactive elements. Users can toggle themes; the
              site also honors the operating system preference on first load.
            </li>
            <li>
              Alternative text on meaningful imagery; decorative icons marked{' '}
              <code>aria-hidden</code> so they don't add screen-reader noise.
            </li>
            <li>
              Reduced-motion preferences are respected — animations and
              transitions are minimized when the operating system reports
              that preference.
            </li>
            <li>
              The interactive map exposes coordinate input fields and
              keyboard-actionable controls; pin position can be set via the
              latitude / longitude form in addition to drag.
            </li>
          </ul>
        </PolicySection>

        <PolicySection heading="Known limitations">
          <ul>
            <li>
              Some embedded map interactions rely on pointer events; we work
              to add equivalent keyboard alternatives where practical, but the
              underlying map library has functionality (e.g. drag-and-drop
              pin) that may not be fully accessible to keyboard-only users.
            </li>
            <li>
              The interactive OpenAPI reference at <code>/docs</code> is
              powered by a third-party library with its own accessibility
              characteristics. We've selected its theme to maximize contrast
              in both modes; some elements within that view may not match
              the rest of the site's accessibility profile.
            </li>
          </ul>
        </PolicySection>

        <PolicySection heading="Feedback">
          <p>
            We treat accessibility as an ongoing concern, not a checkbox.
            If you encounter a barrier and want to suggest a fix, the open
            nature of this project means most improvements happen by way of
            contributions to the same channels through which the service is
            distributed.
          </p>
        </PolicySection>
      </PolicyShell>
    </SiteLayout>
  )
}
